import mime from "mime"
import { Files, Network } from "../../.."
import { REVERSE_MIME_TYPES } from "../../../constants"
import { formatDate } from "../../../formating"
import APIWrapper, { axiosWrapperV2 } from "../../APIWrapper"

export class EmployerReportAttributes extends APIWrapper {
	constructor(attr) {
		super()
		Object.assign(this, attr)
	}
}

export default class EmployerReport extends EmployerReportAttributes {
	static async getAll({ employerId }) {
		const { data } = await axiosWrapperV2.send({
			method: "GET",
			url: `employer/${employerId}/report`
		})

		return data.data.map((r) => new this(r))
	}

	static async getOne({ id, employerId }) {
		const { data } = await axiosWrapperV2.send({
			method: "GET",
			url: `employer/${employerId}/report?id=${id}`
		})

		return new this(data.data[0])
	}

	get fileType() {
		return mime.getExtension(this.file.mimeType)?.toUpperCase()
	}

	get tableValues() {
		return {
			name: this.displayName,
			type: REVERSE_MIME_TYPES[this.file.mimeType] || this.file.mimeType,
			date: formatDate({
				data: this.lastDate,
				actions: ["display"]
			})
			// If needed:
			// firstDate: formatDate({
			//   data: this.firstDate,
			//   actions: ["display"],
			// }),
		}
	}

	async serve() {
		await Files.handleDownloadOrView({
			action: "download",
			...this.links.serve,
			name: this.displayName,
			type: this.file.mimeType
		})
	}

	async delete() {
		try {
			if (this.links?.delete) {
				await Network.AxiosWrapperV2.send({ ...this.links.delete })
			}
		} catch (err) {
			console.error(err)
		}
	}
}
